/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GraphMutationRemoveEdge = zod.object({
  fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
  toContentUuid: zod.uuid().describe('UUID v4 identifier'),
});

export type GraphMutationRemoveEdge = zod.input<typeof GraphMutationRemoveEdge>;
export type GraphMutationRemoveEdgeOutput = zod.output<typeof GraphMutationRemoveEdge>;
